module.exports = __webpack_public_path__ + "static/icon-menu-objectStorage.4defe80d.svg";